(() => {
  const data = document.querySelector('[data-bulk-config]');
  if (!data) return;
  const config = JSON.parse(data.textContent);
  const main = document.querySelector('main');
  if (!main || !config?.variants) return;
  const price = main.querySelector('[data-price]');
  let note = main.querySelector('[data-bulk-product]');
  if (!note && price) {
    note = document.createElement('small');
    note.className = 'dls-bulk-price';
    note.dataset.bulkProduct = '';
    note.setAttribute('aria-live', 'polite');
    const container = price.closest('.dz-price,.dp-price,.dk-price,.dls-medals__price') || price;
    container.after(note);
  }
  if (!note) return;
  const money = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'});
  function update() {
    const field = main.querySelector('form[action*="/cart/add"] [name="id"]');
    const id = field?.value || new URLSearchParams(location.search).get('variant') || data.dataset.initialVariant;
    const tier = config.variants[id];
    note.hidden = !tier;
    const message = tier ? `Bij grotere aantallen vanaf ${money.format(tier.cents / 100)} per stuk · bij ${tier.quantity} stuks` : '';
    if (note.textContent !== message) note.textContent = message;
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  }
  main.addEventListener('change', schedule);
  main.addEventListener('input', schedule);
  main.addEventListener('click', schedule);
  if (price) new MutationObserver(schedule).observe(price, {childList:true, subtree:true, characterData:true});
  update();
})();
